import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'default' | 'light';
}
export function CountdownTimer({
  variant = 'default'
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown();
  const badgeClass = variant === 'light' ? 'bg-white text-red-600' : 'bg-red-600 text-white';
  return <div className="flex items-center justify-center gap-2" data-id="element-49">
      <div className={`${badgeClass} px-4 py-2 rounded-lg font-bold text-2xl min-w-[60px] text-center`} data-id="element-50">
        00
      </div>
      <span className={variant === 'light' ? 'text-white text-2xl font-bold' : 'text-gray-700 text-2xl font-bold'} data-id="element-51">
        :
      </span>
      <div className={`${badgeClass} px-4 py-2 rounded-lg font-bold text-2xl min-w-[60px] text-center`} data-id="element-52">
        {String(minutes).padStart(2, '0')}
      </div>
      <span className={variant === 'light' ? 'text-white text-2xl font-bold' : 'text-gray-700 text-2xl font-bold'} data-id="element-53">
        :
      </span>
      <div className={`${badgeClass} px-4 py-2 rounded-lg font-bold text-2xl min-w-[60px] text-center`} data-id="element-54">
        {String(seconds).padStart(2, '0')}
      </div>
    </div>;
}